import React from "react";

function TextBox({ type = 'text', name, value, placeholder, onChange }) {
	return <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder} className=' mb-4 px-3 py-[12px] block w-full rounded-md border-0 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-secondary sm:text-sm sm:leading-6 outline-none' />;
}

export default TextBox;
